<template>
  <div>
    <h3>{{ $t('message.script_security_remote_login') | title }}</h3>

    <div v-if="willRunOnEachClusterNode" class="cluster-info">
      {{ $t('message.will_run_on_each_cluster_node') | title }}
    </div>
    <div v-if="willRunOnThisClusterNodeOnly" class="cluster-info">
      {{ $t('message.will_run_on_this_cluster_node_only') | title }}
    </div>

    <div class="description">
      {{$t('message.script_security_remote_login_desc')}}
    </div>
    <b-form enctype="multipart/form-data" align-h="center" v-if="enabled != null && enabled != undefined">
      <b-form-row>
        <label class="label label-default col-2">
          {{'enabled' | title}}
        </label>
        <!-- <b-form-checkbox v-model="enabled" class="col"/> -->
        <div class="col">
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input col" v-model="enabled"/>
          </div>
        </div>
      </b-form-row>

      <b-form-row>
        <label class="label label-default col-2">
          {{'port' | title}}
        </label>
        <b-form-input type="number" v-model="port" class="col"/>
      </b-form-row>

      <b-button :disabled="runInProgress" class="padmin-button submit-button"
        @click="setRemoteLogin" variant="primary">
        <b-spinner v-if="runInProgress" small type="grow"/>
        {{$t('message.button_save') | title}}
      </b-button>

    </b-form>

    <b-row>
      <b-col>
        <ConsoleOutput v-if="result != null" :result="result" :output="output"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ConsoleOutput from "./ConsoleOutput";
import { get, post } from "../http";

export default {
  name: "RemoteLogin",

  components: {
    ConsoleOutput
  },

  data() {
    return {
      result: null,
      output: "",
      enabled: null,
      port: null,
      runInProgress: false
    };
  },

  mounted() {
    this.loadStatus()
  },

  methods: {
    loadStatus() {
      this.clean()
      this.runInProgress = true
      get("/remote_login").then(
        resp => {
          this.runInProgress = false
          this.willRunOnEachClusterNode = resp.data.will_run_on_each_cluster_node
          this.willRunOnThisClusterNodeOnly = resp.data.will_run_on_this_cluster_node_only
          if (resp.data.error) {
            this.result = false
            this.output = resp.data.error
          } else {
            this.enabled = resp.data.enabled
            this.port = resp.data.port
          }
        },
        err => {
          console.log("err", err)
          this.runInProgress = false
          this.result = false
          this.output = err
        }
      )
    },

    setRemoteLogin() {
      this.clean()
      this.runInProgress = true
      post('/remote_login', {'enable': this.enabled, 'port': this.port}).then(
        resp => {
          this.runInProgress = false
          this.result = resp.data.result
          this.output = resp.data.output
        },
        err => {
          console.log('err', err)
          this.runInProgress = false
          this.result = false
          this.output = err
        }
      )
    },

    clean() {
      this.result = null
      this.output = ""
    }
  }
};
</script>

<style scoped>

</style>
